import ScrollTrigger from '@terwanerik/scrolltrigger';
import easing from 'jquery.easing';
import luxy from 'luxy.js';

export class App {
  constructor(){
    this.win = window;
    this.html = document.documentElement;
    this.body = document.body;
    this.header = document.getElementById('masthead');
    this.page = document.getElementById('page');
    this.spin = document.querySelector('.loading');
    this.winH = window.innerHeight;
    this.winW = window.innerwidth;
    this.ua = window.ua;
    this.btn_sp = document.createElement('button');
    this.btn_sp.classList.add('btnSp');
    this.btn_sp.innerHTML = "<div class='btnSp__inner'><span class='bar'></span><span class='bar'></span><span class='bar'></span></div>";
    this.header.appendChild(this.btn_sp);
    this.menuSpContainer = document.createElement('div');
    this.menuSpContainer.classList.add('menuSpContainer');
    this.menuSp = document.getElementById('menu-1').cloneNode(true);
    this.menuBack = document.createElement('div');
    this.menuSp_a = this.menuSp.querySelectorAll('a');
    this.menuBack.classList.add('menuBack');
    this.menuSpContainer.appendChild(this.menuSp);
    this.menuSpContainer.appendChild(this.menuBack);
    this.header.appendChild(this.menuSpContainer);
    this.btn_top = document.createElement('div');
    this.btn_top.classList.add('btnTop');
    this.page.appendChild(this.btn_top);
    this.btnS = document.getElementById('btnS');
    this.judS = false;
    //console.log(mp3);

    // this.html.classList.add('on');
    // this.page.classList.add('on');
    // setTimeout(()=>{
    //   this.trigger();
    // },800);
    
    if(mp3){

      this.vol = vol * 0.01;
      //console.log(this.vol);
      this.mp3 = new Audio();
      this.mp3.preload = "auto";
      this.mp3.autoplay = true;
      this.mp3.volume = this.vol;
      this.mp3.loop = true;
      this.mp3.muted = true;
      this.mp3.src = mp3;
      this.mp3.load();

      //console.log(this.mp3);
    }else{
      this.btnS.classList.add('hide');
    }
  }
  init(){
    // console.log('init');
    // window.focus();

    if(this.body.classList.contains('home')){
      if(document.getElementById('mvArea') !== null){
        this.setScript();
      }

    }
    if(this.ua !== "mobile"){
      // luxy.init({
      //  wrapper:"#page",
      //  targets:'.heroArea__inner--wrap',
      //  wrapperSpeed:0.098//0.095
      // });
    }
    //this.trigger();
    this.events();
  }
  trigger(){
    this.trigger = new ScrollTrigger({
      trigger: {
        offset: {
          viewport: {
            x: 0,
            y: (trigger, rect, direction) => {
              return 0.1;
            }
          }
        },
        toggle: {
          callback: {
            in:(trigger)=>{
            },
            out:(trigger)=>{
            }
          }
        }
      }
    });
    this.trigger.add('[data-scroll]', {
      once: true,
      toggle: {
        class: {
          in: 'animIn',
          out: 'animOut'
        },
        callback: {
          in:(trigger) => {

          },
          out:(trigger) => {

          }
        }
      }
    })
  }
  menuOpen(){
    this.btn_sp.classList.add('on');
    this.menuSpContainer.classList.add('on');
  }
  menuClose(){
    this.btn_sp.classList.remove('on');
    this.menuSpContainer.classList.remove('on');
  }
  events(){
    // window.addEventListener('load',(e)=>{
    //   console.log('load');
    // });
    this.sp = 900;
    this.ease = "easeInOutExpo";
    this.sc_target;

    if(mp3){
      this.mp3.addEventListener('ended',(e)=>{
        // this.mp3.currentTime=0;
        // this.mp3.play();
      });
      this.mp3.addEventListener('loadeddata', (e)=>{
        this.btnS.classList.add('show');
      });
    }

    this.btn_top.addEventListener('click',(e)=>{
      $('html,body').animate({
        scrollTop:0
      },this.sp,this.ease);
    });

    this.btn_sp.addEventListener('click',(e)=>{
      const _this = e.currentTarget;
      if(_this.classList.contains('on')){
        this.menuClose();
      }else{
        this.menuOpen();
      }
    });

    this.menuBack.addEventListener('click',(e)=>{
      this.menuClose();
    });

    for(const _spa of this.menuSp_a){
      _spa.addEventListener('click',(e)=>{
        this.menuClose();
      });
    }


    const atags = document.querySelectorAll('a[href^="#"]');
    for(const _a of atags){
      _a.addEventListener('click',(e)=>{
        e.preventDefault();
        let href = e.currentTarget.getAttribute('href');

        if(href == "#" || ""){
          href = "page";
          this.sp = 1200;
        }else{
          href = href.replace("#","");
        }

        let target = document.getElementById(href);
        //console.log(target)

        const rect = target.getBoundingClientRect();
        //console.log(rect);

        this.anim(rect.top);

      });
    }
    // const ob_options = {
    //   rootMargin:'30%'
    // }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        //console.log(entry.target);
        if(entry.isIntersecting){
          //console.log(this);
          entry.target.classList.add('show');
          this.sc_target = entry.target;

          //console.log(entry.target);
          //window.addEventListener('scroll',this.onScroll);
        }else{
          entry.target.classList.remove('show');
          //window.removeEventListener('scroll',this.onScroll);
        }
      });
    });
    const _threes = document.querySelectorAll('.three');
    for(const _three of _threes){
      observer.observe(_three);
    }


    window.addEventListener('scroll',(e)=>{
      this.onScroll();
    });
    window.addEventListener('resize',(e)=>{
      this.onResize();
    });
    this.onScroll();
    this.onResize();



    this.btnS.addEventListener('click',(e) => {
      if(!this.judS){
        this.judS=true;
        this.btnS.classList.add('on');
        //this.mp3.volume = .8;
        if(mp3){
          this.mp3.muted = false;
        }
      }else{
        this.judS=false;
        this.btnS.classList.remove('on');
        //this.mp3.volume = 0;
        if(mp3){
          this.mp3.muted = true;
        }
      }
    });
  }
  onResize(){
    this.winH = window.innerHeight;
    this.winW = window.innerwidth;
  }
  onScroll(e){

    //const tar = document.querySelector('.threeWrap');
    let scT = window.pageYOffset;
    //console.log((scT + tar.getBoundingClientRect().top));
    if(this.ua !== "mobile"){
    const shows = document.querySelectorAll('.show');
      for( const show of shows){
        //console.log(show);
        let _top = show.getBoundingClientRect().top;
        let _scT = (_top+scT)-(scT+this.winH - 66);
        //console.log();
        // グラデの追従が速すぎるので係数を落とす
        show.style.backgroundPositionY = (_scT * .4)+"px";
      }
    }

    //console.log(app);
    //app.sc_target.style.backgroundPositionY=window.pageYOffset * -2+"px";
    //console.log(app.sc_target.getBoundingClientRect().top,window.pageYOffset * .1);
    //console.log(this.sc_target,window.pageYOffset);
    if(scT > 100){
      this.btn_top.classList.add('on');
    }else{
      if(this.btn_top.classList.contains('on')){
        this.btn_top.classList.remove('on');
      }
    }
  }
  anim(_tar){
    if(_tar){
      const _scTop = window.pageYOffset || document.documentElement.scrollTop;
      setTimeout((e)=>{
        $('html,body').animate({
          scrollTop:_tar + _scTop
        },this.sp,this.ease);
      },100);
    }
  }
  setScript(){
    const _fscript = document.getElementsByTagName('script')[0];
    const _script = document.createElement('script');
    _script.src = "https://www.youtube.com/iframe_api";
    _script.setAttribute('id','ytscript');
    _fscript.parentNode.insertBefore(_script, _fscript);
  }
  setMovie(movies){
    this.ytPlayers = [];
    this.movies = movies;
    this.id = 0;
    this.cur = movies[0]['area'];
    this.items = document.querySelectorAll('.heroArea__inner--item');
    this.callID;
    this.currentPlayer;
    this.byeTime = 8;
    this.offTime = 9;
    this.go = false;
    this.off = false;
    this.bye = false;
    this.firstTime = true;
    this.curTime=0;

    const _this = this;

    for(let i = 0; i<this.movies.length; i++){
      const v_id = movies[i]['url'];
      // console.log(movies[i]);
      let autop = 0;//(i == 0) ? 1 : 0;
      //console.log(autop);
      this.ytPlayers[i] = new YT.Player(
        movies[i]['area'],//"mv"+[i+1],
        {
          width:0,
          height:0,
          videoId:v_id,
          host: "https://www.youtube.com",
          playerVars: {
            playlist:v_id,
            rel:0,
						fs: 0,
						disablekb: 0,
						playsinline:1,
						modestbranding: 1,
						iv_load_policy: 3,
						controls:0,
						showinfo:0,
						wmode: "transparent",
            autoplay:autop,
          },
          events:{
            onReady:onReady,
            onStateChange:onStateChange
          }
        }
      );
    }
    function getTime(){
      _this.callID = requestAnimationFrame(getTime);
      //console.log(_this.byeTime, _this.offTime);
      //console.log(_this.currentPlayer.getCurrentTime());
      _this.curTime = _this.ytPlayers[_this.id].getCurrentTime();
      if(!_this.go){
        //if(_this.currentPlayer.getCurrentTime() > 0){
        if(_this.curTime > 0){
          // console.log(_this.currentPlayer);
          // console.log(_this.id);
          _this.go = true;
          document.getElementById(_this.cur).parentNode.classList.add('go');
          if(_this.firstTime){
            _this.firstTime = false;
            open();
          }
        }
      }

      if(_this.curTime > _this.byeTime){
        //console.log(_this.cur);

        if(!_this.bye){
          _this.bye = true;
          document.getElementById(_this.cur).parentNode.classList.add('bye');
          // console.log("bye=");
          // console.log(_this.currentPlayer);
        }
      }
      if(_this.curTime > _this.offTime){
        if(!_this.off){
          _this.off = true;
          document.getElementById(_this.cur).parentNode.classList.add('off');
          cancelAnimationFrame(_this.callID);
        }
      }
      //console.log(_this.currentPlayer.getCurrentTime());
    }
    function onReady(e){
      // console.log(e.target);
      // console.log(_this.movies);
      // console.log("id="+e.target.id);
      // console.log(e.target.g.id);
      e.target.mute();
      const _tar_id = "mv"+e.target.id; //e.target.g.id;//20230703 fix h → g //20220530 fix
      const _ind = _this.movies.findIndex((u) => u.area === _tar_id);
      // console.log("ind="+_ind);
      const _dur = e.target.getDuration();

      _this.movies[_ind].dur = _dur;

      if(_this.cur == _tar_id){

        const _index = _this.movies.findIndex((u) => u.area === _this.cur);
        _this.id = _index;

        
        e.target.playVideo();
        _this.currentPlayer = e.target;
        _this.byeTime = _dur - 3;
        _this.offTime = _dur - 2;
        getTime();
        setTimeout((e)=>{
          const _f = document.getElementById(_this.cur).parentNode;
          _f.classList.remove('first');
          _f.classList.add('current');

        },100);
        //e.target.playVideo();


        //_this.ytPlayers[_index].playVideo();
        //console.log(_index);
      }

      // setInterval((e)=>{
      //   console.log(_this.currentPlayer.getPlayerState());
      // },1000);
    }
    function onStateChange(state){
      // console.log("state="+state.data);
      if(state.data === YT.PlayerState.ENDED){
        cancelAnimationFrame(_this.callID);
        const _index = _this.movies.findIndex((u) => u.area === _this.cur);


        let _next = 0;//_index + 1;
        if(_index < (_this.movies.length -1)){
          _next = _index + 1;

        }

        _this.cur = _this.movies[_next]['area'];
        // _this.ytPlayers[_next].playVideo();
        clearItem(_next);

        //åconsole.log(_index,_next,_this.movies.length-1);
      }
      //console.log(state.data,YT.PlayerState);
    }
    function clearItem(_next){
      // console.log("next="+_next);
      for(const item of _this.items){
        item.classList.remove('current');
        item.classList.remove('bye');
        item.classList.remove('go');
        item.classList.remove('off');
      }

      _this.byeTime = _this.movies[_next].dur - 3;
      _this.offTime = _this.movies[_next].dur - 2;
      const _cur = document.getElementById(_this.cur);
      _cur.parentNode.classList.add('current');
      // console.log('next state');
      if(_this.ytPlayers[_next].getPlayerState() == 0){
        // console.log('load by id');
        _this.ytPlayers[_next].loadVideoById(_this.movies[_next]['url']);
      }else{
        _this.ytPlayers[_next].playVideo();
      }
      _this.currentPlayer = _this.ytPlayers[_next];
      _this.id = _next;
      setTimeout(()=>{
        if(_this.go){
          _this.go = false;
        }
        if(_this.off){
          _this.off = false;
        }
        if(_this.bye){
          _this.bye = false;
        }
        getTime();
      },100);
      //console.log(_this.currentPlayer);
      //console.log(_cur.parentNode('.heroArea__inner--item'));
    }

    function open(){
      _this.html.classList.add('on');
      _this.page.classList.add('on');
      _this.anim(1);
      $(_this.spin).fadeOut('slow',function(){
        $(this).remove();
        setTimeout(()=>{
          _this.trigger();
        },800);
      });

    }

    window.addEventListener('blur',(e) => {
      // console.log('window.blur');
      if(this.ua === "mobile"){
        this.currentPlayer.stopVideo();
        if(mp3){
          this.mp3.pause();
        }
      }
    });
    window.addEventListener('focus', (e)=> {
      // console.log('window.focus');
      const _state  = this.currentPlayer.getPlayerState();
      // console.log(_state);
      if(_state == 2 || _state == 0 || _state == 5){
        //console.log(this.currentPlayer);
        //console.log(clearItem);
        if(this.ua === "mobile"){
          // console.log('play');
          this.currentPlayer.playVideo();
        }
      }
      if(this.ua === "mobile"){
        if(mp3){
          this.mp3.play();
        }
      }
      //console.log("state="+_state);
    });

    window.addEventListener("pageshow", function(){
      // console.log('pageshow');
      window.focus();

    });

    window.addEventListener("pagehide", function(){
      // console.log('pagehide');

    });

    // const events = [
    //     "pagehide", "pageshow",
    //     "unload", "load"
    //   ];
    //
    //   const eventLogger = event => {
    //     switch (event.type) {
    //       case "pagehide":
    //       case "pageshow":
    //         let isPersisted = event.persisted ? "persisted" : "not persisted";
    //         console.log('Event:', event.type, '-', isPersisted);
    //         break;
    //       default:
    //         console.log('Event:', event.type);
    //         break;
    //     }
    //   };
    //
    //   events.forEach(eventName =>
    //     window.addEventListener(eventName, eventLogger)
    //   );

  }
  // onReady(e){
  //   if(app.cur == e.target.h.id){
  //     const _index = app.movies.findIndex((u) => u.area === app.cur);
  //     app.ytPlayers[_index].mute();
  //     app.ytPlayers[_index].playVideo();
  //     //console.log(_index);
  //   }
  //   // console.log(e.target.h.id);
  //   // console.log(e);
  // }
  // onStateChange(state){
  //   const _id = state.target.h.id;
  //   const _index = app.movies.findIndex((u) => u.area === _id);
  //   console.log(_index);
  //   console.log(state.target.getPlayerState());
  // }
}
